import React from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SelectAddSubjects from '../../../components/select-add-subjects/SelectAddSubjects';
import RouteKey from '../../../routes/key';
import { useWOGAA } from '../../../hooks/wogaa';


const { examRegistrations, viewSelectedSubjects, registerExam } = RouteKey.exam.child;
const { exam } = RouteKey.child;

const ExamSelectSubject = () => {
  const { t } = useTranslation();
  const { uuid: applicationUuid } = useParams<any>();
  const history = useHistory();
  const { state } = useLocation<{ token: string }>();
  const { transactionStart } = useWOGAA('myexamsseab-6451');

    /** WOGAA Registration transaction tracking start
     * */
    transactionStart();

  return (
    <>
      <SelectAddSubjects
        title={t('exam->>SelectSubjects.SelectSubjects')}
        description={t('exam->>SelectSubjects.Instruction')}
        toNavigation={{
          onRouting: () =>
            history.push(
              `/${exam}/${examRegistrations.route}/${applicationUuid}/${viewSelectedSubjects.route}`,
              { token: state && state.token }
            ),
          label: t('exam->>SelectSubjects.ConfirmSelected'),
        }}
        backNavigation={{
          onRouting: (examTypeCode: string) => {
            let path = `/${exam}/${examRegistrations.route}/${registerExam.route}/${examTypeCode}`;

            if (state && state.token) {
              path += `?token=${state.token}`;
            }

            history.push(path);
          },
          label: t('exam->>SelectSubjects.Back'),
        }}
        confirmRouteAndLabel={{
          confirmRoute: `/${exam}/${examRegistrations.route}/${applicationUuid}/${viewSelectedSubjects.route}`,
          confirmLabel: t('exam->>SelectSubjects.ConfirmSelected'),
        }}
      />
    </>
  );
};

export default ExamSelectSubject;
